module.exports = __webpack_public_path__ + "static/img/welcome-screen.3fb11fdb.png";